import Service, { service } from '@ember/service';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';

import type MatchPaymentModel from 'tio-common/models/match-payment';

export default class MatchPaymentService extends Service {
  @service declare store: StoreService;

  async certifyMatchPayments(payments: Array<MatchPaymentModel>) {
    // @ts-expect-error - Ember Data adapter method not typed on MinimumAdapterInterface
    const { data } = await this.store.adapterFor('match-payment').certifyPayments(payments);
    // @ts-expect-error - Ember Data pushPayload expects 2 arguments after rollback
    this.store.pushPayload({ data });
  }
}
